module.exports = __webpack_public_path__ + "static/media/Blog1.dd1ffcea.svg";